<template>
  <div class="order-success-container">
      <div v-if="loading" class="loading-container">
          <i class="el-icon-loading"></i>
          <span>加载中...</span>
       </div>
    <div class="dashboard-tab">
      <h3 class="tab-title">支付成功</h3>
      
      <!-- 支付成功主内容 -->
      <el-card class="success-card">
        <div class="success-content">
          <!-- 成功图标 -->
          <div class="success-icon">
            <i class="el-icon-circle-check"></i>
          </div>
          
          <!-- 成功标题 -->
          <h2 class="success-title">支付成功！</h2>
          
          <!-- 成功描述 -->
          <p class="success-description">
            您的订单已支付成功，系统正在处理中，请耐心等待
          </p>
           <a class="tips">套餐的新购、升级配置、续费需成功支付后，<b>重新登录</b>生效</a>
          <!-- 订单信息>
          <div class="order-details">
            <div class="detail-row">
              <span class="detail-label">订单编号：</span>
              <span class="detail-value">{{ orderNo }}</span>
              <el-button 
                type="text" 
                size="small" 
                @click="copyOrderNo"
                class="copy-btn"
              >
                <i class="el-icon-document-copy"></i> 复制
              </el-button>
            </div>
            
            <div class="detail-row">
              <span class="detail-label">支付金额：</span>
              <span class="detail-value amount">¥{{ formatPrice(amount) }}</span>
            </div>
            
            <div class="detail-row">
              <span class="detail-label">支付方式：</span>
              <span class="detail-value">{{ paymentMethodText }}</span>
            </div -->
            
            <!-- div class="detail-row">
              <span class="detail-label">支付时间：</span>
              <span class="detail-value">{{ formatTime(paymentTime) }}</span>
            </div-->
            
            <!-- div v-if="alipayTradeNo" class="detail-row">
              <span class="detail-label">支付宝交易号：</span>
              <span class="detail-value">{{ alipayTradeNo }}</span>
            </div-->   
          
          <!-- 操作按钮 -->
          <div class="action-buttons">
            <!--el-button 
              type="primary" 
              @click="viewOrderDetail"
              class="view-detail-btn"
            >
              <i class="el-icon-tickets"></i> 查看订单详情
            </el-button -->
            
            <el-button 
              @click="goToHome"
              class="home-btn"
            >
              <i class="el-icon-house"></i> 返回首页
            </el-button>
            
            <el-button 
              @click="goToAdmin"
              class="admin-btn"
            >
              <i class="el-icon-monitor"></i> 进入管理后台
            </el-button>
          </div>
          
          <!-- 温馨提示 -->
          <div class="tips-section">
            <h4 class="tips-title">温馨提示</h4>
            <ul class="tips-list">
              <li>订单支付成功后，相关服务将在1-5分钟内开通</li>
              <li>如有疑问，请联系客服：400-xxx-xxxx</li>
              <li>您可以在"管理后台"查看订单状态和使用服务</li>
              <li>如需发票，请在订单详情中申请</li>
            </ul>
          </div>
        </div>
      </el-card>
      
      <!-- 订单商品列表 -->
      <el-card class="products-card" v-if="orderItems && orderItems.length > 0">
        <div slot="header" class="clearfix">
          <h4>购买商品</h4>
        </div>
        <!-- div class="products-list">
          <div 
            v-for="(item, index) in orderItems" 
            :key="index" 
            class="product-item"
          >
            <div class="product-info">
              <div class="product-name">
                <i v-if="item.itemType === 1" class="el-icon-star-on"></i>
                <i v-else-if="item.itemType === 2" class="el-icon-refresh"></i>
                {{ item.itemName }}
              </div>
              <div class="product-quantity">×{{ item.quantity }}</div>
            </div>
            <div class="product-price">
              ¥{{ formatPrice(item.unitPrice * item.quantity) }}
            </div>
          </div>
        </div -->
      </el-card>
    </div>
  </div>
</template>

<script>
import { getOrderDetail}  from '@/api/tenant/order'
export default {
  name: 'OrderSuccess',
  data() {
    return {
      orderNo: '',
      amount: 0,
      paymentMethod: 'alipay',
      paymentTime: new Date(),
      alipayTradeNo: '',
      orderItems: []
    }
  },
  computed: {
    paymentMethodText() {
      const methods = {
        'alipay': '支付宝支付',
        'wechat': '微信支付'
      }
      return methods[this.paymentMethod] || '在线支付'
    }
  },
  mounted() {
    this.loadOrderData()
    // 设置自动跳转
    this.setAutoRedirect()
  },
  beforeRouteEnter(to, from, next) {
    if (!to.query.orderNo) {
      next('/admin/orders') // 如果没有订单号，跳转到订单列表
    } else {
      next()
    }
  },  
  methods: {
    loadOrderData() {
      // 从URL参数获取订单信息
      const orderNo = this.$route.query.orderNo
      if (orderNo) {
        this.orderNo = orderNo
        // 调用API获取订单详情
        this.fetchOrderDetail(orderNo)
      }
      

      
      // 示例商品数据
      this.orderItems = [
        {
          itemName: '专业版套餐',
          itemType: 1,
          quantity: 1,
          unitPrice: 299.00
        },
        {
          itemName: '智能问答加油包',
          itemType: 2,
          quantity: 2,
          unitPrice: 50.00
        }
      ]
      
      // 计算总金额
     /* this.amount = this.orderItems.reduce((total, item) => {
        return total + (item.unitPrice * item.quantity)
      }, 0)*/
      
      // 如果有支付宝交易号，从路由参数获取
      if (this.$route.query.tradeNo) {
        this.alipayTradeNo = this.$route.query.tradeNo
      }
    },
    
  async fetchOrderDetail(orderNo) {
    this.loading = true
    try {
      const response = await getOrderDetail(orderNo)
      if (response.code === 200) {
        // 处理数据...
      } else {
        this.$message.error('获取订单详情失败')
      }
    } catch (error) {
      console.error('获取订单详情失败:', error)
      this.$message.error('网络错误，请稍后重试')
    } finally {
      this.loading = false
    }
  },
      
    formatPrice(price) {
      if (typeof price !== 'number' || isNaN(price)) {
        return '0.00'
      }
      const rounded = Math.round(price * 100) / 100
      return rounded.toFixed(2)
    },
    
    formatTime(time) {
      if (!time) return ''
      const date = new Date(time)
      return date.toLocaleString('zh-CN', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
      })
    },
    
    copyOrderNo() {
      const input = document.createElement('input')
      input.value = this.orderNo
      document.body.appendChild(input)
      input.select()
      document.execCommand('copy')
      document.body.removeChild(input)
      
      this.$message({
        message: '订单号已复制到剪贴板',
        type: 'success',
        duration: 2000
      })
    },
    
    viewOrderDetail() {
      // 跳转到订单详情页面
      this.$router.push({
        path: '/admin/order/detail',
        query: { orderNo: this.orderNo }
      })
    },
    
    goToHome() {
      this.$router.push('/')
    },
    
    goToAdmin() {
      this.$router.push('/admin/dashboard')
    },
    
    setAutoRedirect() {
      // 5秒后自动跳转到管理后台
      setTimeout(() => {
        this.$message({
          message: '即将跳转到管理后台',
          type: 'info',
          duration: 2000
        })
        
        setTimeout(() => {
          this.goToAdmin()
        }, 2000)
      }, 5000)
    }
  }
}
</script>

<style scoped>
.order-success-container {
  padding: 20px;
  min-height: calc(100vh - 60px);
  background-color: #f5f7fa;
}

.dashboard-tab {
  max-width: 1200px;
  margin: 0 auto;
}

.tab-title {
  color: #333;
  margin-bottom: 25px;
  font-size: 1.5rem;
  font-weight: 500;
}

.success-card {
  margin-bottom: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
}

.success-content {
  text-align: center;
  padding: 40px 20px;
}

.success-icon {
  margin-bottom: 20px;
}

.success-icon i {
  font-size: 80px;
  color: #67c23a;
}

.success-title {
  color: #333;
  font-size: 28px;
  margin-bottom: 15px;
  font-weight: 600;
}

.success-description {
  color: #666;
  font-size: 16px;
  margin-bottom: 30px;
  line-height: 1.6;
}

.order-details {
  max-width: 600px;
  margin: 30px auto;
  padding: 25px;
  background-color: #f9f9f9;
  border-radius: 8px;
  border: 1px solid #ebeef5;
}

.detail-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 0;
  border-bottom: 1px dashed #e0e0e0;
}

.detail-row:last-child {
  border-bottom: none;
}

.detail-label {
  color: #666;
  font-size: 14px;
  min-width: 100px;
  text-align: left;
}

.detail-value {
  flex: 1;
  text-align: left;
  color: #333;
  font-size: 14px;
  font-weight: 500;
}

.detail-value.amount {
  color: #e4393c;
  font-weight: bold;
  font-size: 16px;
}

.copy-btn {
  color: #1296db;
  margin-left: 10px;
}

.copy-btn:hover {
  color: #409eff;
}

.action-buttons {
  display: flex;
  justify-content: center;
  gap: 20px;
  margin: 40px 0;
  flex-wrap: wrap;
}

.view-detail-btn {
  padding: 12px 30px;
  font-size: 16px;
  background-color: #1296db;
  border-color: #1296db;
}

.view-detail-btn:hover {
  background-color: #409eff;
  border-color: #409eff;
}

.home-btn,
.admin-btn {
  padding: 12px 30px;
  font-size: 16px;
}

.tips-section {
  max-width: 800px;
  margin: 40px auto 0;
  padding: 20px;
  background-color: #f0f9ff;
  border-radius: 8px;
  border-left: 4px solid #1296db;
}

.tips-title {
  color: #333;
  font-size: 16px;
  margin-bottom: 15px;
  font-weight: 600;
}

.tips-list {
  text-align: left;
  margin: 0;
  padding-left: 20px;
}

.tips-list li {
  color: #666;
  margin-bottom: 8px;
  line-height: 1.6;
  font-size: 14px;
}

.tips-list li:last-child {
  margin-bottom: 0;
}

.products-card {
  margin-top: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
}

.products-card .clearfix {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.products-list {
  padding: 10px 0;
}

.product-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px;
  margin-bottom: 10px;
  background-color: #f9f9f9;
  border-radius: 6px;
  border: 1px solid #f0f0f0;
}

.product-item:last-child {
  margin-bottom: 0;
}

.product-info {
  display: flex;
  align-items: center;
  flex: 1;
}

.product-name {
  flex: 1;
  color: #333;
  font-size: 14px;
  display: flex;
  align-items: center;
}

.product-name i {
  margin-right: 8px;
  color: #1296db;
}

.product-quantity {
  color: #666;
  font-size: 14px;
  margin-left: 20px;
  min-width: 50px;
}

.product-price {
  color: #e4393c;
  font-weight: bold;
  font-size: 16px;
  min-width: 100px;
  text-align: right;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .success-content {
    padding: 20px 10px;
  }
  
  .success-icon i {
    font-size: 60px;
  }
  
  .success-title {
    font-size: 24px;
  }
  
  .success-description {
    font-size: 14px;
  }
  
  .order-details {
    padding: 15px;
    margin: 20px 0;
  }
  
  .detail-row {
    flex-direction: column;
    align-items: flex-start;
    padding: 10px 0;
  }
  
  .detail-label {
    margin-bottom: 5px;
    min-width: auto;
  }
  
  .action-buttons {
    flex-direction: column;
    gap: 10px;
  }
  
  .view-detail-btn,
  .home-btn,
  .admin-btn {
    width: 100%;
    margin: 0;
  }
  
  .product-item {
    flex-direction: column;
    align-items: flex-start;
  }
  
  .product-price {
    margin-top: 10px;
    text-align: left;
    min-width: auto;
  }  
}

.tips{
  font-family: 微软雅黑;
  font-size:  small;
  color: red;
}
</style>